import { StytchProvider } from "@stytch/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ConfigError } from "./components/states";
import { LOGIN_ORIGIN, MCP_ORIGIN } from "./config";
import { stytchClient } from "./stytch";
import "./styles.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("missing #root element");
}

/**
 * **Three build inputs, and the app cannot do its job without any of them.**
 *
 * The public token is what lets the SDK read the session; `VITE_MCP_ORIGIN` is where every
 * `/app/*` request goes; `VITE_LOGIN_ORIGIN` is the only way a visitor with no session can get
 * one, because sign-in lives on that host and not this one. A bundle missing one of them
 * renders the calm config-error card rather than a page that half works — a panel that loads,
 * shows a chip, and then fails every request is a worse answer than saying so.
 *
 * Checked here, at the root, so there is one place that decides the app is unusable and every
 * component below can assume it is not.
 */
const client = MCP_ORIGIN !== null && LOGIN_ORIGIN !== null ? stytchClient : null;

// One <StytchProvider> for the whole app, as in the login SPA.
createRoot(container).render(
  <StrictMode>
    {client === null ? (
      <ConfigError />
    ) : (
      <StytchProvider stytch={client}>
        <App />
      </StytchProvider>
    )}
  </StrictMode>,
);
